/* BG COM 04/10/2026 (vitesse) : sorti tel quel de sections/bgcom-pdp-stack.liquid (bloc <script> en ligne), chargé en defer. */
  (function(){
    /* bandeau CTA: scroll to the configurator and focus its first field */
    document.addEventListener('click', function(e){
      var a = e.target.closest && e.target.closest('[data-bgs-scroll]');
      if(!a) return;
      var t = document.querySelector(a.getAttribute('data-bgs-scroll'));
      if(!t) return;
      e.preventDefault();
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
      var field = t.querySelector('input:not([type="hidden"]):not([disabled])');
      if(field) setTimeout(function(){ field.focus({ preventScroll: true }); }, reduce ? 0 : 450);
    });
    window.__bgsScroll = 1;   /* 04/10 r3 : le repli onclick du bouton (sections/bgcom-pdp-stack) s'efface */

    /* ── the pack: checkboxes, quantities, real total (pro price when logged in), one add ── */
    (function(){
      var root = document.querySelector('[data-bgb]');
      if(!root) return;
      var items = [].slice.call(root.querySelectorAll('[data-bgb-item]'));
      var elCount = root.querySelector('[data-bgb-count]'), elTotal = root.querySelector('[data-bgb-total]'), elTtc = root.querySelector('[data-bgb-sum-ttc]');
      var elFranco = root.querySelector('[data-bgb-franco]'), elFrancoT = root.querySelector('[data-bgb-franco-t]');
      var btn = root.querySelector('[data-bgb-add]'), lbl = root.querySelector('[data-bgb-label]'), msg = root.querySelector('[data-bgb-msg]');
      var FREE = 30000;
      /* live texts (count, franco line, the add button's label) change at once: the red button and its white label never
         pass through a reduced opacity (jury 30/09, D6). The totals change as whole amounts, never digit by digit: the HT
         total swaps (the old amount leaves 8px up while the new one comes in, 200ms, BGM.amount in bgcom-motion), the TTC
         line only crossfades. Never on the first paint; without the runtime the text is simply written. */
      var live = false;
      function setTxt(el, t){ t = String(t); if(el.textContent !== t) el.textContent = t; }
      function setNum(el, t, o){ var M = window.BGM; if(live && M && typeof M.amount === 'function') M.amount(el, t, o); else { el.textContent = t; el.setAttribute('data-bgm-val', t); } }
      function mainForm(){
        var h = document.querySelector('product-sticky-form');
        var f = h && document.getElementById(h.getAttribute('form'));
        return f || document.querySelector('.product__info form[action*="/cart/add"][id^="product-form"], form[action*="/cart/add"][id^="product-form"]');
      }
      /* the shop's money format (€1.234,50), same as the buy box */
      function euros(c){ var n = Math.max(0, Math.round(c)); return '€' + String(Math.floor(n / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + ('0' + (n % 100)).slice(-2); }
      function cents(txt){ var t = (txt || '').replace(/[^\d,.]/g, ''); if(!t) return null; t = t.replace(/\.(?=\d{3}(\D|$))/g, '').replace(',', '.'); var n = parseFloat(t); return isNaN(n) ? null : Math.round(n * 100); }
      /* Offre du mois (11/10/2026, assets/bgcom-promo-holo.js) : un produit qui porte l'étiquette compte à son prix remisé (total, franco) */
      function unit(it){ var pe = it.querySelector('.bgpp[data-bgpp-pro]:not([hidden])'); if(pe) return +pe.getAttribute('data-bgpp-pro'); /* pro chez qui la promo gagne : prix promo, jamais promo sur prix pro */
        var u = unit0(it); return window.bgcomOffreNet ? window.bgcomOffreNet(it, u) : u; }
      function unit0(it){
        if(it.dataset.kind === 'current'){
          /* the buy box already shows the exact HT price of the chosen variant, pro price included */
          var el = document.querySelector('.product__info .bgcom-product-header__price .bgcom-price-ht .bgcom-money') || document.querySelector('.product__info .bgcom-price-ht .bgcom-money');
          var c = el && cents(el.textContent);
          if(c) return c;
        }
        var price = +it.dataset.price, first = +it.dataset.first || price;
        var pro = it.querySelector('.bgcom-samita-target[data-customer="1"]');
        var w = window.bgcomWholesaleData && window.bgcomWholesaleData[it.dataset.pid];
        return (pro && w && first) ? Math.round(price * w / first) : price;
      }
      /* the page product's personalisation lives in the buy box; the pack only reads / writes it */
      function curSummary(){
        var f = mainForm(), parts = [], seen = {};
        if(!f) return '';
        [].forEach.call(f.elements, function(el){
          if(!el.name || !/^properties\[/.test(el.name) || el.disabled || seen[el.name]) return;
          seen[el.name] = 1;
          var v = el.type === 'radio' ? f.elements[el.name].value : el.value;
          if(v && String(v).trim()) parts.push(String(v).trim().replace(/\s*\(.*\)$/, ''));
        });
        return parts.join(' · ');
      }
      function isSet(it){
        if(!it.querySelector('[data-bgb-dlg]')) return true;
        if(it.dataset.kind === 'current'){ var f = mainForm(); return !f || !firstInvalid(f); }
        return it.classList.contains('is-set');
      }
      function cfgState(){
        var cur = items.filter(function(i){ return i.dataset.kind === 'current'; })[0];
        var t = cur && cur.querySelector('[data-bgb-sum-t]');
        if(!t) return;
        var ok = isSet(cur), sum = curSummary();
        t.textContent = ok && sum ? sum : 'Teinte à choisir';
        var b = cur.querySelector('[data-bgb-open]'); if(b) b.textContent = ok ? 'Modifier' : 'Choisir';
      }
      function sync(){
        var n = 0, q = 0, total = 0;
        items.forEach(function(it){
          var cb = it.querySelector('[data-bgb-check]');
          if(!cb) return;
          var on = cb.checked, qi = it.querySelector('[data-bgb-qty]');
          var qty = Math.min(999, Math.max(1, parseInt(qi.value, 10) || 1)); qi.value = qty;
          it.classList.toggle('is-on', on);
          qi.disabled = !on; it.querySelectorAll('[data-bgb-step]').forEach(function(b){ b.disabled = !on; });
          var u = unit(it);
          if(it.dataset.kind === 'current'){
            var box = it.querySelector('.bgb-price'), src = document.querySelector('.product__info .bgcom-product-header__price .bgcom-product-price-stack');
            if(box && src && src.querySelector('.bgcom-price-ht')){ var h = src.innerHTML.replace(/<i class="bgm-spark"[^>]*><\/i>/g, '').replace(/ is-spk/g, ''); if(box.innerHTML !== h) box.innerHTML = h; }
            else { var ht = it.querySelector('[data-bgb-ht]'), ttc = it.querySelector('[data-bgb-ttc]'); if(ht) ht.textContent = euros(u); if(ttc) ttc.textContent = euros(u * 1.2); }
          }
          if(on){ n++; q += qty; total += u * qty; }
        });
        setTxt(elCount, n ? (n + (n > 1 ? ' produits sélectionnés' : ' produit sélectionné') + (q > n ? ' · ' + q + ' articles' : '')) : 'Aucun produit sélectionné');
        setNum(elTotal, euros(total)); setNum(elTtc, euros(total * 1.2), { fade:true });
        var ok = total >= FREE;
        elFranco.classList.toggle('is-ok', ok);
        setTxt(elFrancoT, ok ? 'Ce pack est livré franco de port' : 'Franco de port dès 300 € HT (hors cartons de crochets)');
        if(!btn.classList.contains('is-busy') && !btn.classList.contains('is-ok')){
          btn.disabled = !n;
          setTxt(lbl, !n ? 'Sélectionnez un produit' : (n > 1 ? 'Ajouter les ' + n + ' produits' : 'Ajouter au panier'));
        }
        cfgState();
        live = true;
      }
      function firstInvalid(f){
        for(var i = 0; i < f.elements.length; i++){ var el = f.elements[i]; if(el.willValidate && el.type !== 'hidden' && !el.checkValidity()) return el; }
        return null;
      }
      function say(t, err){ msg.innerHTML = t; msg.classList.toggle('is-err', !!err); }
      /* ── options pop-up: complements that need a shade / a variant are chosen here, not on another page ── */
      function propsOf(it){ try{ return JSON.parse(it.dataset.props || 'null'); }catch(_){ return null; } }
      function mainProp(name){
        var f = mainForm(), el = f && f.elements['properties[' + name + ']'];
        return el ? (el.value || '') : '';
      }
      function valOf(field){
        var c = field.querySelector('input[type=radio]:checked'); if(c) return c.value;
        var i = field.querySelector('input:not([type=radio]), select, textarea'); return i ? i.value : '';
      }
      function dlgRules(dlg){
        dlg.querySelectorAll('[data-bgb-hide-when]').forEach(function(fd){
          var r; try{ r = JSON.parse(fd.getAttribute('data-bgb-hide-when')); }catch(_){ return; }
          var trig = [].filter.call(dlg.querySelectorAll('[data-bgb-field]'), function(x){ return x.getAttribute('data-bgb-field') === r.field; })[0];
          var hide = !!trig && valOf(trig) === r.equals;
          fd.hidden = hide;
          fd.querySelectorAll('input, select, textarea').forEach(function(i){ i.disabled = hide; });
        });
      }
      var queue = [];   /* items whose options are asked right before the add (choose first, personalise after) */
      /* 04/10/2026 (vitesse r5.1) : the pop-up's form waits in a <template data-bgb-tpl> (snippets/bgcom-bundle-item, ~50 nodes per
         item out of the page) and is put in its <dialog> the first time it opens ; everything below reads the dialog after this */
      function ensureDlg(dlg){
        var t = dlg && dlg.querySelector('template[data-bgb-tpl]');
        if(t){ dlg.appendChild(document.importNode(t.content, true)); t.parentNode.removeChild(t); }
        return dlg;
      }
      function openDlg(it, inQueue){
        var dlg = it.querySelector('[data-bgb-dlg]'); if(!dlg) return;
        ensureDlg(dlg);
        var cur = it.dataset.kind === 'current', p = cur ? {} : (propsOf(it) || {});
        dlg.querySelectorAll('[data-prop]').forEach(function(inp){
          var k = inp.getAttribute('data-prop'), v = (p[k] != null) ? p[k] : mainProp(k);
          if(inp.type === 'radio'){ if(v || cur) inp.checked = (inp.value === v); }
          else if(cur || (!inp.value && v)) inp.value = v || '';
        });
        dlgRules(dlg);
        dlg.querySelector('[data-bgb-dlg-msg]').textContent = '';
        var sub = dlg.querySelector('[data-bgb-dlg-sub]'), ok = dlg.querySelector('[data-bgb-dlg-ok]'), cancel = dlg.querySelector('.bgb-dlg__cancel');
        if(inQueue){
          sub.textContent = 'Dernière étape avant l’ajout au panier';
          ok.textContent = queue.length > 1 ? 'Valider et continuer' : 'Valider et ajouter au panier';
          cancel.textContent = 'Retirer du pack'; cancel.setAttribute('data-mode', 'remove');
        } else {
          sub.textContent = cur ? 'Personnalisation du produit (aussi mise à jour en haut de page)' : 'Options de ce produit';
          ok.textContent = 'Valider';
          cancel.textContent = 'Annuler'; cancel.removeAttribute('data-mode');
        }
        if(typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
        var empty = [].filter.call(dlg.querySelectorAll('[required]:not([disabled])'), function(i){ return i.type === 'radio' ? !dlg.querySelector('input[name="' + i.name + '"]:checked') : !String(i.value).trim(); })[0];
        var target = empty || dlg.querySelector('.bgb-dlg__ok');
        setTimeout(function(){ try{ target.focus(); }catch(_){} }, 30);
      }
      function saveDlg(form){
        var dlg = form.closest('[data-bgb-dlg]'), it = form.closest('[data-bgb-item]'), note = dlg.querySelector('[data-bgb-dlg-msg]');
        var bad = [].filter.call(form.querySelectorAll('[required]:not([disabled])'), function(i){ return i.type === 'radio' ? !form.querySelector('input[name="' + i.name + '"]:checked') : !String(i.value).trim(); })[0];
        if(bad){
          var lab = bad.closest('.bgb-dlg__f').querySelector('.bgb-dlg__l');
          note.textContent = 'Indiquez « ' + (lab ? lab.textContent.replace('*', '').trim() : 'ce champ') + ' » pour ajouter ce produit au pack.';
          try{ bad.focus(); }catch(_){}
          return;
        }
        var props = {}, parts = [];
        form.querySelectorAll('[data-prop]').forEach(function(inp){
          if(inp.disabled) return;
          var k = inp.getAttribute('data-prop');
          if(inp.type === 'radio'){ if(inp.checked){ props[k] = inp.value; parts.push(inp.value.replace(/\s*\(.*\)$/, '')); } }
          else if(String(inp.value).trim()){ props[k] = inp.value.trim(); parts.push(inp.value.trim()); }
        });
        var vs = form.querySelector('[data-bgb-variant]');
        if(vs){
          var o = vs.options[vs.selectedIndex];
          it.dataset.vid = o.value; it.dataset.price = o.getAttribute('data-price');
          parts.unshift(o.textContent.trim());
          var cw = it.querySelector('.bgcom-card-wrap'); if(cw){ cw.setAttribute('data-variant-id', o.value); cw.setAttribute('data-price', o.getAttribute('data-price')); }
          var tg = cw && cw.querySelector('.bgcom-samita-target');
          if(window.bgcomOffreRepaint) window.bgcomOffreRepaint(it, +o.getAttribute('data-price'));
          if(tg && window.bgcomRenderPrices){ delete tg.dataset.bgcomState; window.bgcomRenderPrices(cw); }
          else { var u = unit(it), ht = it.querySelector('.bgcom-price-ht .bgcom-money'), ttc = it.querySelector('.bgcom-price-ttc .bgcom-money');
            if(ht) ht.textContent = euros(u); if(ttc) ttc.textContent = euros(u * 1.2); }
        }
        if(it.dataset.kind === 'current') writeMain(form);
        else {
          it.dataset.props = JSON.stringify(props);
          it.classList.add('is-set');
          var st = it.querySelector('[data-bgb-sum-t]'); if(st) st.textContent = parts.join(' · ');
          var ob = it.querySelector('[data-bgb-open]'); if(ob) ob.textContent = 'Modifier';
        }
        it.querySelector('[data-bgb-check]').checked = true;
        dlg.dataset.done = '1';
        if(dlg.open) dlg.close();
        sync();
        if(queue[0] === it){ queue.shift(); next(); }
      }
      /* write the pop-up's answers into the buy box's own fields (their own change listeners then run) */
      function writeMain(form){
        var f = mainForm(); if(!f) return;
        form.querySelectorAll('[data-prop]').forEach(function(inp){
          if(inp.disabled || (inp.type === 'radio' && !inp.checked)) return;
          var el = f.elements['properties[' + inp.getAttribute('data-prop') + ']'];
          if(!el) return;
          var list = (typeof RadioNodeList !== 'undefined' && el instanceof RadioNodeList) ? [].slice.call(el) : [el];
          list.forEach(function(m){
            if(m.type === 'radio'){ var on = m.value === inp.value; if(m.checked !== on){ m.checked = on; if(on) m.dispatchEvent(new Event('change', { bubbles:true })); } }
            else { m.value = String(inp.value).trim(); m.dispatchEvent(new Event('input', { bubbles:true })); m.dispatchEvent(new Event('change', { bubbles:true })); }
          });
        });
      }
      function next(){ if(queue.length) openDlg(queue[0], true); else add(); }
      function add(){
        /* options still to choose on selected items: ask them now, one pop-up after the other, then add */
        if(!queue.length){
          var missing = items.filter(function(it){ var cb = it.querySelector('[data-bgb-check]'); return cb && cb.checked && !isSet(it); });
          if(missing.length){ queue = missing; say(''); openDlg(queue[0], true); return; }
        }
        var lines = [], cur = null;
        items.forEach(function(it){
          var cb = it.querySelector('[data-bgb-check]');
          if(!cb || !cb.checked) return;
          var qty = Math.max(1, parseInt(it.querySelector('[data-bgb-qty]').value, 10) || 1);
          if(it.dataset.kind === 'current'){ cur = qty; return; }
          var line = { id: +it.dataset.vid, quantity: qty }, pr = propsOf(it);
          if(pr && Object.keys(pr).length) line.properties = pr;
          lines.push(line);
        });
        if(cur){
          var f = mainForm();
          if(!f){ say('Ajoutez ce produit depuis le bloc d’achat en haut de page.', true); return; }
          var bad = firstInvalid(f);
          if(bad){
            say('Complétez d’abord la personnalisation du produit (champ requis).', true);
            var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
            bad.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
            setTimeout(function(){ try{ bad.focus({ preventScroll:true }); bad.reportValidity(); }catch(_){} }, reduce ? 0 : 700);
            return;
          }
          var fd = new FormData(f), props = {};
          fd.forEach(function(v, k){ var m = /^properties\[(.+)\]$/.exec(k); if(m && String(v).trim() !== '') props[m[1]] = v; });
          var line = { id: +fd.get('id'), quantity: cur };
          if(Object.keys(props).length) line.properties = props;
          lines.unshift(line);
        }
        if(!lines.length) return;
        btn.disabled = true; btn.classList.add('is-busy'); setTxt(lbl, 'Ajout en cours…'); say('');
        fetch('/cart/add.js', { method:'POST', headers:{ 'Content-Type':'application/json', 'Accept':'application/json' }, body: JSON.stringify({ items: lines }) })
          .then(function(r){ return r.json().then(function(j){ if(!r.ok) throw j; return j; }); })
          .then(function(){ return fetch('/cart.js').then(function(r){ return r.json(); }); })
          .then(function(cart){
            document.querySelectorAll('cart-count, .cart-count, [data-cart-count]').forEach(function(c){ c.textContent = cart.item_count; });
            document.dispatchEvent(new CustomEvent('bgh:added', { detail:{ cart: cart } }));
            btn.classList.remove('is-busy'); btn.classList.add('is-ok'); btn.disabled = false;
            setTxt(lbl, 'Ajouté au panier');
            say('<a href="/cart">Voir le panier</a>');
            /* open the cart like the buy-box button does: the site cart is the Espace Pro drawer (Fly app), theme drawer as fallback */
            try{
              if(typeof window.bgproOpen === 'function') window.bgproOpen();
              else { var cd = document.querySelector('cart-drawer'); if(cd && cd.show) cd.show(btn); }
            }catch(_){}
            setTimeout(function(){ btn.classList.remove('is-ok'); sync(); }, 3500);
          })
          .catch(function(e){
            btn.classList.remove('is-busy'); sync();
            say((e && (e.description || e.message)) ? String(e.description || e.message) : 'L’ajout n’a pas abouti, réessayez.', true);
          });
      }
      root.addEventListener('change', function(e){
        var dlg = e.target.closest('[data-bgb-dlg]');
        if(dlg){ dlgRules(dlg); return; }
        if(e.target.matches('[data-bgb-check], [data-bgb-qty]')) sync();
      });
      root.addEventListener('submit', function(e){
        var form = e.target.closest('[data-bgb-form]'); if(!form) return;
        e.preventDefault(); saveDlg(form);
      });
      root.addEventListener('click', function(e){
        var op = e.target.closest('[data-bgb-open]'); if(op){ openDlg(op.closest('[data-bgb-item]')); return; }
        var cl = e.target.closest('[data-bgb-close]');
        if(cl){
          var d = cl.closest('[data-bgb-dlg]'), owner = d && d.closest('[data-bgb-item]');
          if(cl.getAttribute('data-mode') === 'remove' && owner){
            /* « Retirer du pack »: drop this product, carry on with the others */
            owner.querySelector('[data-bgb-check]').checked = false;
            d.dataset.done = '1'; if(d.open) d.close(); sync();
            if(queue[0] === owner){ queue.shift(); next(); }
            return;
          }
          if(d && d.open) d.close();
          return;
        }
        if(e.target.matches('[data-bgb-dlg]')){ e.target.close(); return; }  /* click on the backdrop */
        var s = e.target.closest('[data-bgb-step]');
        if(s){ var qi = s.closest('.bgb-qty').querySelector('[data-bgb-qty]'); qi.value = Math.max(1, (parseInt(qi.value, 10) || 1) + (+s.getAttribute('data-bgb-step'))); sync(); return; }
        if(e.target.closest('[data-bgb-add]')) add();
      });
      /* the chosen variant, the personalisation and the pro prices can all change after load */
      /* closing a pop-up of the add sequence without an answer pauses the add, without an error tone */
      root.querySelectorAll('[data-bgb-dlg]').forEach(function(d){
        d.addEventListener('close', function(){
          if(d.dataset.done){ delete d.dataset.done; return; }
          if(queue.length){ queue = []; say('Ajout en pause : choisissez les options pour l’ajouter au panier.'); }
        });
      });
      document.addEventListener('change', function(e){ if(!root.contains(e.target)) setTimeout(sync, 60); });
      document.addEventListener('input', function(e){ if(!root.contains(e.target) && /^properties\[/.test(e.target.name || '')) cfgState(); });
      var priceEl = document.querySelector('.product__info .bgcom-product-header__price');
      if(priceEl && 'MutationObserver' in window) new MutationObserver(function(){ sync(); }).observe(priceEl, { childList:true, subtree:true, characterData:true });
      [0, 900, 2000, 4000].forEach(function(t){ setTimeout(sync, t); });
    })();

    /* ── motion (shared runtime snippets/bgcom-motion): queued, runs once the runtime is up at the end of <body> ──
       Owner's rule (30/09), on top of the jury fixes: ONE grammar for every section, late and slow enough to be seen.
       The runtime fires a reveal when the element's top reaches 80% of the screen, 700ms per element, and shows at once
       whatever is scrolled past fast (already more than 60% on screen). This block only says WHAT comes in:
       - section titles (and the Bandeau title) first: the title rises 20px (14px on phones), its text fades in and the red
         "//" draws itself in from the left; no word split, no blur;
       - then the secondary text (subtitles, links, notes, the FAQ aside): a fade 160ms later;
       - then the content, one element after another (90ms apart): the two Pourquoi columns, the steps, the pack tiles
         (each from its own place) with their + signs, the FAQ questions (70ms), the documents; the spec table rows fade in
         one after another without moving (reference data), 40ms apart; "Produits similaires" (loaded later) the same way;
       - images: a fade that settles from scale 1.02;
       - never hidden: the pack price panel with its total and its add button, the Bandeau button, every buying control
         (BGM.keep) and the 3D exploded view. */
    (window.BGMq = window.BGMq || []).push(function(M){
      var mods = '.bgs__mod:not(.bgs-x3d) ';                     /* never touch the pinned 3D section */
      M.reveal(mods + '.bgs__h2, .bgs-band__h', 'words');
      M.reveal([mods + '.bgs__sub', '.bgs-comp__all', '.bgs-how__note', '.bgs-faq__aside > p', '.bgs-faq__sign'].join(','), 'fade', { delay:160 });
      M.reveal('.bgb__items', 'up', { items:'.bgb-item', stagger:90, also:[{ items:'.bgb__plus', preset:'fade', delay:90, stagger:90 }] });
      M.reveal('.bgs-why', 'up', { items:'.bgs-why__facts, .bgs-why__list', stagger:90 });
      M.reveal('.bgs-apps', 'up');
      /* Bandeau: the photo and the text around the button; its card and its red button stay put */
      M.reveal('.bgs-band__img img', 'blur');
      M.reveal('.bgs-band__eyebrow, .bgs-band__p, .bgs-band__pts', 'up');
      M.reveal('.bgs-steps', 'up', { items:'.bgs-step', stagger:90 });
      M.reveal('.bgs-how__media img', 'blur');
      M.reveal('.bgs-guide', 'up');
      M.reveal('.bgs-faq__list', 'up', { items:'details', stagger:70 });
      /* owner's rule (30/09): the reference data enters too, gently: spec rows fade in one after another (no movement),
         documents rise one after another */
      M.reveal('.bgs-sc-grid', 'fade', { items:'tr, .bgs-sc__h, h3', stagger:40 });
      M.reveal('.bgs-docs__list', 'up', { items:'.bgs-docs__a', stagger:90 });
      /* "Produits similaires" loads after the page (theme recommendations): same entrance as every module once its cards exist */
      (function waitReco(n){
        var reco = document.querySelector('[id$="__product-recommendations"]');
        if(reco && reco.querySelector('.product-card')){
          M.reveal('[id$="__product-recommendations"] .bgs__h2', 'words');
          M.reveal('[id$="__product-recommendations"] .card-grid', 'up', { items:'.product-card', stagger:90 });
        } else if(n < 40) setTimeout(function(){ waitReco(n + 1); }, 250);
      })(0);
      /* FAQ hover pill: mouse only, opaque, above the row hairlines and under the row's text (runtime 'over' mode) */
      M.glide('.bgs-faq__list', 'summary', { px:12, py:0, radius:12, color:'rgba(23,23,23,.05)', over:true });
      M.gate('.bgb-side');
    });

    /* guide card arrow: a second copy of the arrow for the dropship icon swap (the circle is aria-hidden) */
    [].forEach.call(document.querySelectorAll('.bgs-guide__arrow'), function(a){
      var s = a.querySelector('.bgi');
      if(!s || a.querySelector('.bgm-swap-in')) return;
      var c = s.cloneNode(true);
      s.classList.add('bgm-swap-out'); c.classList.add('bgm-swap-in');
      a.appendChild(c);
    });

    /* FAQ accordion (jury 30/09, D7): the row really grows. The details element's own height goes from its closed height
       to its open height (both measured), so the questions below slide instead of jumping; the answer is clipped to that
       height (clip-path, so the summary's focus ring is never cut) and its text fades in over 200ms from the same start.
       Out-curve, 300ms for an answer up to about 120px, then 2.45ms per pixel of travel (483ms at 197px, 735ms at 300px,
       750ms at most): the curve starts at about 3.65x its mean speed, so one 60Hz frame (16.7ms) moves the rows below by
       at most 25px up to about 305px of travel; past the 750ms cap the step grows with the answer (about 32px at 400px).
       The + turns on the same duration (--faq-d, set here; bgm-opening holds it still while the open row is measured).
       Closing is the same fold backwards: the + turns back, the text fades out, the row shrinks, and the open attribute
       is removed only at the end. A click during a fold turns it around from where it is. Enter / Space on the summary
       and the details semantics stay the browser's own (they reach us as the summary's click). Reduced motion, or no
       Element.animate: the browser's instant toggle. */
    (function(){
      var list = document.querySelector('.bgs-faq__list');
      if(!list || typeof Element.prototype.animate !== 'function') return;
      var OUT = 'cubic-bezier(.2,.7,.2,1)';
      function stop(det){ var l = det._bgmF; det._bgmF = null; (l || []).forEach(function(x){ try{ x.cancel(); }catch(_){} }); }
      function shutH(det, s){ var cs = getComputedStyle(det); return s.getBoundingClientRect().height + (parseFloat(cs.borderTopWidth) || 0) + (parseFloat(cs.borderBottomWidth) || 0); }
      list.addEventListener('click', function(e){
        var s = e.target.closest && e.target.closest('summary');
        if(!s || !list.contains(s) || e.defaultPrevented) return;
        if(window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        var det = s.parentElement, a = det && det.querySelector('.bgs-faq__a');
        if(!a || det.tagName !== 'DETAILS' || s !== det.querySelector('summary')) return;
        e.preventDefault();
        var opening = !det.open || det.classList.contains('bgm-closing');
        /* where the fold is right now (mid-fold when a click turns it around), read before anything is cancelled */
        var from = det.getBoundingClientRect().height, op = parseFloat(getComputedStyle(a).opacity), was = det.open;
        if(isNaN(op)) op = 1;
        stop(det);
        var shut = shutH(det, s);
        if(!was){ det.classList.add('bgm-opening'); det.open = true; from = shut; op = 0; }
        var full = det.getBoundingClientRect().height, ans = Math.max(0, full - shut), to = opening ? full : shut;
        var dur = Math.round(Math.min(750, Math.max(300, Math.abs(to - from) * 2.45))), anims = [];
        det.style.setProperty('--faq-d', dur + 'ms');
        det.classList.remove('bgm-opening');
        det.classList.toggle('bgm-closing', !opening);
        function clip(h){ return 'inset(0px 0px ' + Math.max(0, ans - (h - shut)).toFixed(2) + 'px 0px)'; }
        function done(){ if(!opening){ det.open = false; det.classList.remove('bgm-closing'); } det.style.removeProperty('--faq-d'); stop(det); }
        try{
          anims.push(det.animate({ height: [from + 'px', to + 'px'] }, { duration: dur, easing: OUT, fill: 'forwards' }));
          anims.push(a.animate({ clipPath: [clip(from), clip(to)] }, { duration: dur, easing: OUT, fill: 'forwards' }));
          anims.push(a.animate({ opacity: [op, opening ? 1 : 0] }, { duration: 200, easing: OUT, fill: 'forwards' }));
        }catch(_){
          anims.forEach(function(x){ try{ x.cancel(); }catch(__){} });
          done(); return;
        }
        det._bgmF = anims;
        anims[0].onfinish = function(){ if(det._bgmF === anims) done(); };
      });
    })();

    /* manufacturer video: swap the poster for the player only when asked (privacy-enhanced domain) */
    document.addEventListener('click', function(e){
      var b = e.target.closest && e.target.closest('[data-bgs-yt]');
      if(!b) return;
      var f = document.createElement('iframe');
      f.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(b.getAttribute('data-bgs-yt')) + '?autoplay=1&rel=0&hl=fr';
      f.title = (b.getAttribute('aria-label') || '').replace(/^Lire la vidéo : /, '');
      f.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture; web-share';
      f.allowFullscreen = true;
      f.referrerPolicy = 'strict-origin-when-cross-origin';
      b.replaceWith(f);
      f.focus();
    });

    /* never show the same product in "Complétez" and "Produits similaires":
       complementary = to use WITH this product, similar = INSTEAD of it */
    var comp = document.querySelector('[data-bgs-comp]');
    if(!comp) return;
    var urls = [].map.call(comp.querySelectorAll('[data-bgs-url]'), function(c){ return c.getAttribute('data-bgs-url'); });
    if(!urls.length) return;
    function dedupe(){
      var reco = document.querySelector('[id$="__product-recommendations"]');
      if(!reco) return;
      reco.querySelectorAll('.product-card').forEach(function(card){
        var a = card.querySelector('a[href]'); if(!a) return;
        var path = a.getAttribute('href').split('?')[0];
        /* remove the card itself only: the theme slider re-wraps cells, so an
           ancestor lookup could match the whole track and wipe the row */
        if(urls.indexOf(path) > -1 && card.parentElement && card.parentElement.classList.contains('card-grid')){
          card.remove();
        }
      });
    }
    /* the recommendations section sits below this script in the HTML: wait for it */
    function start(){
      dedupe();
      var reco = document.querySelector('[id$="__product-recommendations"]');
      if(reco) new MutationObserver(dedupe).observe(reco, { childList:true, subtree:true });
    }
    if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  })();
